export function fetchConfig() {
  return fetch("/config/config.json")
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(
        `Unable to configure FE: ${response.status} ${response.statusText}`,
      );
    })
    .catch((error) => {
      throw new Error(`Problem fetching configuration: ${error.message}`);
    });
}
